import { customersApi } from '@texas/api/endpoints/customersApi';
import { SearchQuery, EntityItem } from '../../../types';
import { randomIdentifier } from '@texas/utils/helpers/commonHelpers';
import { ChatMessageEntityLinkType } from '@texas/api/endpoints/chat/chatApi';

export async function searchCustomers(
  query: SearchQuery,
): Promise<EntityItem[]> {
  const response = await customersApi.filterCustomers({
    customerName: query.query,
    limit: 100,
    assignedTo: null,
  });

  if (response.hasError) {
    return [];
  }

  return response.data.map((c) => ({
    id: c.id,
    name: c.name,
    type: ChatMessageEntityLinkType.Customer,
    identifier: randomIdentifier(),
  }));
}
